import script from "./system-protection.vue?vue&type=script&setup=true&lang=ts"
export * from "./system-protection.vue?vue&type=script&setup=true&lang=ts"

import "./system-protection.vue?vue&type=style&index=0&id=3036958e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3036958e"]])

export default __exports__